<template>
    <PendingRequests></PendingRequests>
</template>
<script>
    import PendingRequests from '@/components/EmployeePendingRequests.vue'
    export default {
        name: 'pending-requests',
        components: {
            PendingRequests
        }
    }
</script>